import React from 'react';

import { CategoriesForm } from '../../Form/Forms';

export default ({
  selected,
}) => (
    <CategoriesForm selected={selected} />
  );
